<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-form @submit.prevent="submit">
            <base-card title="Search Form" icon="mdi-filter-variant">
                  <v-row dense class="pt-2 px-2">
                    <v-col lg="3" md="2" cols="12">
                      <v-date-input input-format="dd/mm/yyyy" label="From Date" density="compact" prepend-icon=""
                        prepend-inner-icon="mdi mdi-calendar-month" variant="outlined" bg-color="grey-lighten-4"
                        v-model="from_date.value.value" :error-messages="from_date.errorMessage.value"
                        autocomplete="off" clearable></v-date-input>
                    </v-col>

                    <v-col lg="3" md="2" cols="12">
                      <v-date-input input-format="dd/mm/yyyy" label="To Date" density="compact" prepend-icon=""
                        prepend-inner-icon="mdi mdi-calendar-month" variant="outlined" bg-color="grey-lighten-4"
                        v-model="to_date.value.value" :error-messages="to_date.errorMessage.value" autocomplete="off"
                        clearable></v-date-input>
                    </v-col>
                  </v-row>
              <v-divider></v-divider>
              <v-card-actions class="d-flex justify-end">
                <v-btn class="bg-brand ml-2 mb-2" type="submit" ref="searchButton" prepend-icon="mdi-magnify">
                  Search
                </v-btn>
              </v-card-actions>
            </base-card>
          </v-form>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid style="margin-top: -20px;">
      <v-row>
        <v-col cols="12">
          <base-card
            title="Sale Collection List"
            icon="mdi-cash-multiple"
            :v-card-text-class="'pa-0'"
            :loading-allowed="false"
          >
                <v-row class="py-2">
                  <v-col md="4" cols="12">
                    <v-text-field v-model="search" append-inner-icon="mdi-magnify" label="Search" single-line
                      hide-details density="compact" variant="outlined" bg-color="grey-lighten-4" class="pl-2"
                      clearable></v-text-field>
                  </v-col>

                  <v-col md="5" cols="12">
                    <div class="d-flex align-center flex-column">
                      <v-btn-group variant="outlined" density="compact" size="x-small" divided>
                        <v-btn prepend-icon="mdi mdi-download" variant="flat" color="success"
                          @click="exportToCSV">CSV</v-btn>
                        <v-btn prepend-icon="mdi mdi-download" variant="flat" color="primary"
                          @click="exportToExcel">EXCEL</v-btn>
                        <v-btn prepend-icon="mdi mdi-download" variant="flat" color="red"
                          @click="exportToPDF">PDF</v-btn>
                      </v-btn-group>
                    </div>
                  </v-col>

                  <v-col md="3" cols="12">
                  </v-col>
                </v-row>
                <v-data-table :headers="headers" :items="getSchema" :loading="loading"
                  v-model:items-per-page="itemsPerPage" :search="search" :hover="true" density="compact">
                  <template v-slot:loader>
                    <v-progress-linear
                      :color="loading"
                      height="3"
                      indeterminate
                    />
                  </template>
                  <template v-slot:item.index="{ index }">
                    {{ ++index }}
                  </template>

                  <template v-slot:item.sale_invoice_delivery="{ item }">
                    {{ item.sale_invoice_delivery.code ? item.sale_invoice_delivery.code : '' }}
                  </template>

                  <template v-slot:item.sale_invoice="{ item }">
                    {{ item.sale_invoice.code ? item?.sale_invoice?.code : '' }}
                  </template>

                  <template v-slot:item.customer="{ item }">
                    {{ item.customer?.company_name ? item.customer.company_name : '' }}
                  </template>

                  <template v-slot:item.approved_ind="{ item }">
                    <v-chip v-if="item.approved_ind == 1" color="success" size="small"
                      class="text-capitalize">Yes</v-chip>
                    <v-chip v-else color="red" size="small" class="text-capitalize">No</v-chip>
                  </template>

                  <template v-slot:item.status="{ item }">
                    <v-chip :color="statusMap[item.status]?.color || 'grey'" size="small" class="text-capitalize">
                      {{ statusMap[item.status]?.label || "Unknown" }}
                    </v-chip>
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-icon class="me-2" color="blue" @click="viewCollectionDetails(item)" title="View Collection Details">
                      mdi-eye-outline
                    </v-icon>
                  </template>
                </v-data-table>
          </base-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref, nextTick } from "vue";
import { toast } from "vue3-toastify";
import { shallowRef } from "vue";
import formattedDate from "@/plugins/dateFormatter";
import statusMap from "@/utils/statusMap";
import BaseCard from "@/components/utils/baseCard.vue";

export default {
  components: {
    BaseCard,
  },
  data: () => ({
    itemsPerPage: 10,
    panel: [0],
    loading: false,
    search: "",
    dialog: false,
    data: {},
    statusMap,
    headers: [
      { title: "#SL", align: "center", key: "index", width: "7%", sortable: false },
      { title: "Code", key: "code", align: "center", sortable: false },
      { title: "Payment Date", key: "payment_date", align: "center", sortable: false },
      { title: "SO No.", key: "sale_invoice_delivery.invoice_master.code", align: "center", sortable: false },
      { title: "Invoice No.", key: "sale_invoice", align: "center", sortable: false },
      { title: "Customer", key: "customer", align: "center", sortable: false },
      { title: "Payment Method", key: "payment_type", align: "center", sortable: false },
      { title: "Amount", key: "amount", align: "center", sortable: false },
      { title: "Discount", key: "discount", align: "center", sortable: false },
      { title: "Net Collection", key: "net_collection", align: "center", sortable: false },
      { title: "Due", key: "due", align: "center", sortable: false },
      { title: "Status", align: "center", key: "status", sortable: true },
      { title: "Actions", align: "center", key: "actions", sortable: false },

    ],
  }),
  watch: {
  },
  created() {
    // if(this.$store.getters.getProjectList.length === 0) {this.$store.dispatch('getProjectList');}
  },
  computed: {
    getSchema() {
      return this.$store.getters.getCustomerPaymentList;
    },
  },
  setup() {
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        // from_date: yup.date().required().label('From Date'),
        // to_date: yup.date().required().label('To Date'),
      }),
    });

    const customer_id = useField("customer_id");
    const from_date = useField("from_date");
    const to_date = useField("to_date");
    const errorMessages = ref("");
    const loading = ref("");
    const store = useStore();
    const submit = handleSubmit((values) => {
      loading.value = true;
      values.from_date = formattedDate(from_date.value.value);
      values.to_date = formattedDate(to_date.value.value);
      store
        .dispatch("getCustomerPaymentList", values)
        .then((response) => {
          loading.value = false;
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        });
    });
    return {
      submit,
      from_date,
      to_date,
      errorMessages,
      customer_id,
      loading,
    };
  },
  methods: {
    goTo(val) {
      this.$router.push({ path: val }).catch((err) => { });
    },
    editItem(item) {
      // this.$store.commit('setEditingRfq', item);
      this.$router.push({
        name: "add-sale-invoice",
        query: { id: item.id },
      });
      // this.data = { ...item };
      // this.dialog = true;
    },
    viewCollectionDetails(item) {
      // Navigate to linked Accounts Receipt Voucher using voucher_master id
      if (item.voucher_master && item.voucher_master.id) {
        const route = this.$router.resolve({
          name: "view-receipt-voucher",
          params: { id: item.voucher_master.id },
        });
        window.open(route.href, "_blank");
      } else {
        toast.info("Receipt voucher not found for this customer payment");
      }
    },
    exportToPDF() {
      let serialNumber = 1;
      const columns = [
        "#SL",
        "PR Code",
        "Warehouse",
        "Amount",
        "Approval Status",
        "PR Status",
      ];
      const rows = this.getSchema.map((item) => [
        serialNumber++,
        item.code,
        item.warehouse.name,
        item.amount,
        item.approved_ind === 1 ? "YES" : "NO",
        ,
        item.status == 1 ? "POST" : "DRAFT",
      ]);
      this.$exportTableToPDF(
        columns,
        rows,
        "Purchase Order List",
        "purchase_order_record_" + this.$fileDate(),
        "landscape"
      );
    },
    exportToExcel() {
      var data = [
        [
          "#SL",
          "PR Code",
          "Warehouse",
          "Amount",
          "Approval Status",
          "PR Status",
        ],
      ];
      var serialNumber = 1;
      this.getSchema.forEach((item) => {
        data.push([
          serialNumber++,
          item.code,
          item.warehouse.name,
          item.amount,
          item.approved_ind === 1 ? "YES" : "NO",
          ,
          item.status == 1 ? "POST" : "DRAFT",
        ]);
      });
      this.$exportTableToExcel(data, "purchase_order_record_" + this.$fileDate());
    },
    exportToCSV() {
      var data = [
        [
          "#SL",
          "PR Code",
          "Warehouse",
          "Amount",
          "Approval Status",
          "PR Status",
        ],
      ];
      var serialNumber = 1;
      this.getSchema.forEach((item) => {
        data.push([
          serialNumber++,
          item.code,
          item.warehouse.name,
          item.amount,
          item.approved_ind === 1 ? "YES" : "NO",
          ,
          item.status == 1 ? "POST" : "DRAFT",
        ]);
      });

      this.$exportTableToCSV(data, "purchase_order_record_" + this.$fileDate());
    },
  },
  mounted() {
    const today = new Date();
    const oneMonthBack = new Date();
    oneMonthBack.setMonth(today.getMonth() - 1);
    this.from_date.value.value = oneMonthBack;
    this.to_date.value.value = today;
    
    this.$nextTick(() => {
      this.$refs.searchButton.$el.click();
    });
  },
};
</script>
